import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/brand/brand/apps/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import CustomVideoPlayer from '../../../src/components/custom-video-player';
import ComponentLayout from '../../../src/layouts/component-layout';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const DoDontContainer = makeShortcode("DoDontContainer");
const Do = makeShortcode("Do");
const Caption = makeShortcode("Caption");
const Dont = makeShortcode("Dont");
const layoutProps = {
  _frontmatter
};
const MDXLayout = ComponentLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <h2>{`Anatomy`}</h2>
    <p><img parentName="p" {...{
        "src": "https://github.com/primer/brand/assets/6951037/8b973760-6ddc-441a-a36a-8c4c282bfdcf",
        "alt": "An image displaying a section intro with a title, description and a link."
      }}></img></p>
    <ul>
      <li parentName="ul">{`Label: An optional label to provide leading context to the section intro.`}</li>
      <li parentName="ul">{`Heading: The title of the section.`}</li>
      <li parentName="ul">{`Description: An optional description of the section.`}</li>
      <li parentName="ul">{`Link: An optional link to expand on the content introduced.`}</li>
    </ul>
    <h2>{`Usage`}</h2>
    <p>{`Use the section intro to introduce a new section element in the page. The section intro uses the full-width of the screen and can be used in conjunction with other components that expand the content introduced. For example, the `}<a parentName="p" {...{
        "href": "/brand/components/Card"
      }}>{`card`}</a>{` or the `}<a parentName="p" {...{
        "href": "/brand/components/Pillar"
      }}>{`pillar`}</a>{` components.`}</p>
    <p>{`We recommmend using the section intro as a header of an HTML `}<inlineCode parentName="p">{`<section>`}</inlineCode>{` element. Sections divide the content of the page into thematic groups and represent standalone elements that are typically related to a specific topic or subject within the document.`}</p>
    <p>{`Sections are designed to be self-contained, meaning they should make sense and be meaningful even when viewed independently from the rest of the page. They provide a way to divide the content into meaningful and structured blocks.`}</p>
    <p>{`Ensure the description is concise, keeping it to one paragraph. Use a link to direct users to a page with further details if needed.`}</p>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://github.com/primer/brand/assets/6951037/6cfa8d47-7fe6-4ead-8c3b-d1ccf5e2fc36" />
    <Caption mdxType="Caption">
      Use section intros to introduce a new topic in a section and combine it
      with other components and content.
    </Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://github.com/primer/brand/assets/6951037/f9ee0d4f-5ad5-4b31-9a8c-6533cd199096" />
    <Caption mdxType="Caption">
      Don't use it as standalone element followed by other section intros.
    </Caption>
  </Dont>
    </DoDontContainer>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://github.com/primer/design/assets/175638/f8bd5ed9-d716-40c2-aef6-33979a87784d" />
    <Caption mdxType="Caption">Use a short description to introduce the section.</Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://github.com/primer/design/assets/175638/c2985d40-94c0-436c-9947-6c98611a0c77" />
    <Caption mdxType="Caption">Don't use section intro for long form content.</Caption>
  </Dont>
    </DoDontContainer>
    <h2>{`Options`}</h2>
    <h3>{`Align`}</h3>
    <p>{`Section intro can be aligned to the start or center of the page. By default, the section intro is aligned to the start of the page to allow for an image or a visual asset to be positioned on the left. Use the center alignment if the asset is centered, not present, or the scenario calls for it.`}</p>
    <DoDontContainer stacked mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://github.com/primer/brand/assets/6951037/06f00622-baf4-45b8-b044-b90642d837e9" />
    <Caption mdxType="Caption">
      Use center alignment if the section intro is paired with a centered image
      or visual asset.
    </Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://github.com/primer/brand/assets/6951037/67da7e5d-4535-4f80-bbce-b6e0a7708dee" />
    <Caption mdxType="Caption">
      Don't use center alignment if the section intro is paired with an image or
      visual asset aligned to the left.
    </Caption>
  </Dont>
    </DoDontContainer>
    <h3>{`Emphasized text`}</h3>
    <p>{`Section intro allows for only one portion of the heading to be highlighted. Use strategically to highlight key ideas and guide effectively through a story.`}</p>
    <p><img parentName="p" {...{
        "src": "https://github.com/primer/brand/assets/6951037/d583e4f4-7ce6-426d-be08-5afc704ac611",
        "alt": "An image displaying a section intro with emphasized text."
      }}></img></p>
    <h2>{`Related components`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/brand/components/Hero"
        }}>{`Hero`}</a>{`: Use the hero component to render a full-width banner on a webpage.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/brand/components/CTABanner"
        }}>{`CTABanner`}</a>{`: To draw attention to or create urgency around a user action.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      